import { useState } from 'react';
import Modal from 'react-responsive-modal';

interface IImageModal {
  images: string[];
  modalIsOpen: boolean;
  toggleModal: () => void;
}

export function ImageModal({ images, modalIsOpen, toggleModal }: IImageModal) {
  const [imageIndex, setImageIndex] = useState<number>(0);
  return (
    <>
      {images && (
        <Modal
          open={modalIsOpen}
          onClose={toggleModal}
          center
          styles={{
            modal: {
              width: '80%', // Define a largura do modal para 80% da tela
              maxWidth: '80%', // Garante que o modal não ultrapasse 80% da largura da tela
              height: '80%', // Define a largura do modal para 80% da tela
              maxHeight: '80%',
            },
          }}
        >
          <div
            style={{
              position: 'relative',
              textAlign: 'center',
              height: '100%',
            }}
          >
            {images.length > 1 && (
              <button
                onClick={() => {
                  imageIndex === 0
                    ? setImageIndex(images.length - 1)
                    : setImageIndex(imageIndex - 1);
                }}
                style={{
                  position: 'absolute',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  color: 'white',
                  border: 'none',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  left: '10px',
                }}
              >
                <i className="material-icons-outlined">arrow_back_ios</i>
              </button>
            )}
            <img
              src={images[imageIndex]}
              alt="imagem do empreendimento"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain', // Garante que a imagem ocupe todo o espaço da div
              }}
            />
            {images.length > 1 && (
              <button
                onClick={() => {
                  imageIndex === images.length - 1
                    ? setImageIndex(0)
                    : setImageIndex(imageIndex + 1);
                }}
                style={{
                  position: 'absolute',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  color: 'white',
                  border: 'none',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  right: '10px',
                }}
              >
                <i className="material-icons-outlined">arrow_forward_ios</i>
              </button>
            )}
          </div>
        </Modal>
      )}
    </>
  );
}
